import clsx from 'clsx'
import React from 'react'
import { Icon, Input, Modal } from '../../../components'
import CoinsList from '../CoinsList'
import { Popover } from 'react-tiny-popover'

import './Coin.scss'
import { isDesktop } from '../../../utils'

const Coin = ({
   className,
   label,
   name,
   valueInUsd,
   image,
   unit,
   value,
   onChange,
   coins,
   onCoinSelect,
   isDarkTheme,
}) => {
   const [isCoinsListOpen, setIsCoinListOpen] = React.useState(false)
   const [isCoinPopoverOpen, setIsCoinPopoverOpen] = React.useState(false)

   const getConversion = () => {
      try{
         return (parseFloat(document.getElementById('from-coin-input').value)*(parseFloat(document.getElementById('from-coin').innerHTML)/parseFloat(document.getElementById('to-coin').innerHTML))).toFixed(6)
      }catch{
         return 0
      }
   }

   return (
      <>
         <div className={clsx('Coin', className, isDarkTheme && 'Coin--dark')}>
            <div className="Coin__label">{label}</div>
            <div className="Coin__wrapper">
               <div className="Coin__wrapper-top">
                  <small className="Coin__wrapper-top-name">{name}</small>
                  {!!onChange ? (
                     <small className="Coin__wrapper-top-usd" id="from-coin">{valueInUsd}</small>
                  ) : (
                     <small className="Coin__wrapper-top-usd" id="to-coin">{valueInUsd}</small>
                  )}
               </div>
               <div className="Coin__wrapper-bottom">
                  <Popover
                     isOpen={isCoinPopoverOpen}
                     positions={['bottom', 'right', 'left', 'top']}
                     content={
                        <CoinsList
                           coins={coins}
                           onCoinSelect={coin => {
                              onCoinSelect(coin)
                              setIsCoinPopoverOpen(false)
                           }}
                           inPopover={true}
                        />
                     }
                     onClickOutside={() => setIsCoinPopoverOpen(false)}
                  >
                     <div
                        className="Coin__wrapper-bottom-selector"
                        onClick={() =>
                           isDesktop()
                              ? setIsCoinPopoverOpen(true)
                              : setIsCoinListOpen(true)
                        }
                     >
                        {!!image && (
                           <img
                              className="Coin__wrapper-bottom-selector-image"
                              src={image}
                              alt={name}
                           />
                        )}
                        <span className="Coin__wrapper-bottom-selector-unit">
                           {unit}
                        </span>
                        <Icon
                           className="Coin__wrapper-bottom-selector-down"
                           name="chevron-down"
                        />
                     </div>
                  </Popover>
                  {!!onChange ? (
                     <div className="Coin__wrapper-bottom-input-wrapper">
                        <Input
                           value={value}
                           onChange={onChange}
                           className="Coin__wrapper-bottom-input"
                           id="from-coin-input"
                        />
                     </div>
                  ) : (
                     <span className="Coin__wrapper-bottom-value">{getConversion()}</span>
                  )}
               </div>
            </div>
         </div>
         <Modal
            heading="Coins"
            isOpen={isCoinsListOpen}
            close={() => setIsCoinListOpen(false)}
            isDarkTheme={isDarkTheme}
         >
            <CoinsList
               coins={coins}
               onCoinSelect={coin => {
                  onCoinSelect(coin)
                  setIsCoinListOpen(false)
               }}
            />
         </Modal>
      </>
   )
}

export default Coin
